import React from 'react'
import {
  Flex,
  Details,
} from '@nautilusjs/component-core'
import { Box } from '@maui/elements'
import { Grid } from '../Grid'

function IpAddressDetails({ data }) {
  if (!data) return

  const {
    asn,
    attributed_associations: associations,
    location,
    network_subnet: subnet
  } = data

  const asnNumber = asn?.number
  const identities = associations?.identities || []
  const matchingOrganization = identities.find(identity => (identity.identity_class === 'Organization'))
  const organization = matchingOrganization?.name
  const formattedLocation = location && `${location.city}, ${location.country}`
  const subnetName = subnet?.name

  if (!subnet && !matchingOrganization && !asnNumber && !location) {
    return null
  }

  return (
    <Grid>
      <Grid.Cell columns={2} style={{ position: 'relative' }}>
        <Details>

          <Flex css={{
            width: '100%',
            flexWrap: 'wrap',
            marginTop: '1rem',
            marginBottom: '1rem',
            dt: {
              whiteSpace: 'nowrap',
              marginTop: '1rem',
              marginBottom: '1rem',
            },
            dd: {
              marginTop: '1rem',
              marginBottom: '1rem',
            }
          }}>
            { subnet && (
              <Box width='50%' display='flex' marginTop='1rem' marginBottom='1rem'>
                <Details.Term>Network Subnet</Details.Term>
                <Details.Definition>{subnetName}</Details.Definition>
              </Box>
            )}
            { matchingOrganization && (
              <Box width='50%' display='flex' marginTop='1rem' marginBottom='1rem'>
                <Details.Term>Org</Details.Term>
                <Details.Definition>{organization}</Details.Definition>
              </Box>
            )}
            { asnNumber && (
              <Box width='50%' display='flex' marginTop='1rem' marginBottom='1rem'>
                <Details.Term>ASN</Details.Term>
                <Details.Definition>{asnNumber}</Details.Definition>
              </Box>
            )}
            { location && (
              <Box width='50%' display='flex' marginTop='1rem' marginBottom='1rem'>
                <Details.Term>GEO</Details.Term>
                <Details.Definition>{formattedLocation}</Details.Definition>
              </Box>
            )}
          </Flex>
        </Details>
      </Grid.Cell>
    </Grid>
  )
}

export default IpAddressDetails
